<script setup>
import { ref, onMounted } from 'vue'
const model = defineModel()
const props = defineProps({
  disableClickOutside: {
    type: Boolean,
    default: false,
  },
  exitButton: {
    type: Boolean,
    default: false,
  },
})
const scrollY = ref(0)
const wrapper = ref(null)
watch(model, () => {
  scrollToView()
})
onMounted(() => {
  scrollToView()
})

async function scrollToView() {
  //window.innerHeight 740px actuall client height of viewable window
  await nextTick()
  const body = document.querySelector('body')
  const html = document.querySelector('html')
  const wrapperElementHeight = wrapper?.value?.clientHeight // 100px
  const topAndBottomLimit = 50
  const scrollPosition = window.scrollY // 500px
  const entirePageHeight = Math.max(
    body.scrollHeight,
    body.offsetHeight,
    html.clientHeight,
    html.scrollHeight,
    html.offsetHeight
  ) // 5000px
  const viewportHeight = window.innerHeight // 250 px
  const fitIntoViewport = (viewportHeight - wrapperElementHeight) / 2 // 250 - 100 = 150px /2 50px
  const realFitIntoViewport = fitIntoViewport > topAndBottomLimit ? fitIntoViewport : topAndBottomLimit // if 50 > 50 = 50px if 250 > 50 = 250 if 25 > 50 = 50
  const topOffset = realFitIntoViewport + scrollPosition // 50 + 500 = 550px from top
  const realTopOffset =
    topOffset + wrapperElementHeight > entirePageHeight - topAndBottomLimit
      ? entirePageHeight - wrapperElementHeight - topAndBottomLimit
      : topOffset // So it wont overflow if user is at the bottom

  scrollY.value = realTopOffset
}
</script>
<template>
  <template v-if="model">
    <div class="popUp">
      <div ref="wrapper" class="wholeWrapper" id="popUp">
        <div class="exitContainer">
          <button v-if="exitButton" class="btn-close exit" @click="model = false"></button>
        </div>
        <slot></slot>
      </div>
      <button
        class="cover"
        @click="
          () => {
            if (!props.disableClickOutside) model = false
          }
        "
      ></button>
    </div>
  </template>
</template>
<style scoped>
.popUp {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.exitContainer {
  display: flex;
  justify-content: flex-end;
}
.exit {
  width: 12px;
  height: 12px;
  border: none;
  background-repeat: no-repeat;
  background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23e85c0c'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e");
}
.wholeWrapper {
  position: relative;
  max-width: 80vw;
  width: fit-content;
  border-radius: 8px 20px 8px 20px;
  background-color: #fff;
  padding: 24px;
  z-index: 99992;
}
.cover {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000000a3;
  z-index: 99991;
}
</style>
